import { PackageOpen, Truck, Coffee, Flag } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr, getSavedPos, STATUS } from "@/lib/api";
import { useTacho } from "@/context/TachoContext";
import { BigButton } from "@/components/BigButton";
import { t } from "@/i18n";

const BTNS = [
  { key: "carico", icon: PackageOpen, label: "Carico in corso", sub: "Sto caricando la merce" },
  { key: "in_viaggio", icon: Truck, label: "Partito", sub: "Viaggio in corso" },
  { key: "pausa", icon: Coffee, label: "In pausa", sub: "Sono fermo per riposo" },
  { key: "arrivato", icon: Flag, label: "Arrivato", sub: "Sono a destinazione" },
];

export const StatusButtons = ({ trip, onChange }) => {
  const { refresh } = useTacho();
  const set = async (status) => {
    if (status === trip.status) return;
    const p = getSavedPos() || (trip.last_position ? [trip.last_position.lat, trip.last_position.lng] : null);
    try {
      const { data } = await api.post(`/trips/${trip.id}/status`, { status, lat: p?.[0], lng: p?.[1] });
      toast.success(t("Stato aggiornato: {s}. Il vettore è stato avvisato.", { s: t(STATUS[status].label) }));
      onChange?.(data);
      refresh();
    } catch (e) {
      toast.error(formatErr(e));
    }
  };
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="status-buttons">
      {BTNS.map((b) => (
        <BigButton
          key={b.key}
          testId={`status-btn-${b.key}`}
          icon={b.icon}
          label={t(b.label)}
          sub={trip.status === b.key ? t("STATO ATTUALE") : t(b.sub)}
          color={STATUS[b.key].color}
          variant="outline"
          active={trip.status === b.key}
          onClick={() => set(b.key)}
        />
      ))}
    </div>
  );
};
